export function getEmphasisTerms(workflow, index) {
  const steps = workflow.steps
  const roleLabels = (workflow.roles || []).map(role => role.label)
  const chips = [...(steps[index].chips || []), ...(steps[index + 1]?.chips || [])]
  return [...new Set(chips.map(chip => chip.split(' · ')[0]).filter(term =>
    term.length > 6 && !roleLabels.some(label => label.includes(term)) &&
    String(steps[index].copy || '').includes(term)
  ))].sort((left, right) => right.length - left.length)
}

export function splitEmphasis(copy, terms) {
  if (!terms.length) return [{ text: copy, bold: false }]
  const parts = []
  let rest = copy
  while (rest) {
    const matches = terms.map(term => ({ term, index: rest.indexOf(term) })).filter(match => match.index !== -1)
    if (!matches.length) {
      parts.push({ text: rest, bold: false })
      break
    }
    const match = matches.sort((left, right) => left.index - right.index)[0]
    if (match.index) parts.push({ text: rest.slice(0, match.index), bold: false })
    parts.push({ text: match.term, bold: true })
    rest = rest.slice(match.index + match.term.length)
  }
  return parts
}
